<template>
    <div class="contest-log">
        <div class="top">
            <div class="title-box">
                <div class="main-title">我的参赛记录</div>
                <div class="desc">查看你参与的所有服装设计赛事与作品</div>
            </div>
            <div class="search-box">
                <input v-model="query.keyword" class="search-input" placeholder="输入关键词进行搜索" @keyup.enter="onGetList" />
                    <Icon type="md-search" class="search-ico" @click="onGetList" />
            </div>
        </div>
        <div class="list-body">
            <div class="list-item" v-for="(item,index) in list" :key="index">
                <div class="item-img-box">
                    <div :class="['tag',item.match.status_label]">{{item.match.status_name}}</div>
                    <!-- TODO 入围评审功能开发后此处需接入 -->
                    <div v-if="false" class="has-in">很遗憾!未入围</div>
                    <img :src="item.match.cover|default_img" alt="" class="cover-img" />
                </div>
                <div class="text-content-box">
                    <div class="match-title">{{item.match.title}}</div>
                    <div class="match-time">赛事时间:{{item.match.start_time|date_format('YYYY/MM/DD')}}-{{item.match.end_time|date_format('YYYY/MM/DD')}}</div>
                    <div class="match-works-title">
                        <div class="label">作品标题:</div>
                        <div :class="['value',{'no-works':!item.posts}]" :title="item.posts ? `《${item.posts.title}》`: '-'">{{ item.posts ? `《${item.posts.title}》` : '暂未上传作品' }}</div>
                    </div>
                    <div class="btn-box">
                        <div class="btn-item" @click="onViewDetail(item.match.uuid)">查看详情</div>
                        <div :class="['btn-item',{active:!item.posts && item.match && item.match.status_name != 'end'}]" @click="onUploadClick(item)">{{ item.posts ? '查看作品' : '上传作品' }}</div>
                    </div>
                </div>
            </div>
        </div>
        <Page :current="query.page" :page-size="query.limit" :total="total" @on-change="onChangePage" show-total style="margin-top: 20px;"></Page>
        <SubmitResult v-if="show_result" @close="onCloseSubmitResult" @confirm="onSubmitResultConfirm" @apply="onApply"></SubmitResult>
        <SubmitWorks v-if="show_upload" :detail="matchDetail" :matchUUID="currentMatchUuid" :formData="form" @close="onCloseSubmitWorks" @confirm="onSubmitWorksConfirm"></SubmitWorks>
    </div>
</template>
<script>
import { SaveDraft } from '@/api/index';
import { GetMatchDetail, GetMatchRecordList, MatchSignInCheck } from '@/api/social';
import SubmitResult from '../ContestDetail/components/SubmitResult';
import SubmitWorks from '../ContestDetail/components/SubmitWorks.vue';
export default{
    components: {
        SubmitResult,
        SubmitWorks
    },
    data(){
        return{
            query:{
                keyword:'',
                page:1,
                limit:10
            },
            total:0,
            list:[],
            show_upload: false,
            show_result: false,
            currentMatchUuid: '',
            matchDetail: {},
            form: {
                title: "",
                image_list: [],
                content: "",
                is_agree: false,
                custom_field: []
            }
        }
    },
    computed: {
        is_login() {
            return this.$store.state.is_login;
        }
    },
    mounted(){
        this.onGetList();
    },
    methods:{
        onChangePage(page){
            this.query.page = page;
            this.onGetList();
        },
        async onGetList(){
            try{
                const {code,msg,data} = await GetMatchRecordList(this.query);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('data-record',data);
                this.total = data.count;
                this.list = data.list;
            }catch(err){
                console.log('err',err);
            }
        },
        onViewDetail(uuid) {
            this.$router.push({ name: 'ContestDetail', params: { uuid } });
        },
        async onUploadClick(item) {
            try {
                if (!this.is_login) {
                    this.$layer.msg("请先登录");
                    this.$router.push({ 
                        name: "Login", 
                        query: { 
                            back_params: JSON.stringify({ uuid: item.match.uuid }), 
                            back_name: 'MatchLog' 
                        } 
                    });
                    return;
                }

                const { data } = await MatchSignInCheck({ uuid: item.match.uuid });
                console.log('signin-check-data', data);
                if (!data.is_signin) {
                    this.$layer.msg('请先报名比赛');
                    return;
                }

                // 从报名检查接口获取作品信息
                const { posts } = item;
                console.log('posts', posts);
                
                this.currentMatchUuid = item.match.uuid;
                
                if (posts && posts.uuid) {
                    // 已有作品，跳转到作品详情页
                    await localStorage.setItem('match_upload', JSON.stringify({ ...posts, match_uuid: item.match.uuid }));
                    this.$router.push({ name: 'WorksDetail', query: { uuid: posts.uuid } });
                    return;
                }
                
                // 没有作品，获取大赛详情后打开上传作品弹窗
                await this.onGetMatchDetail(item.match.uuid);
                this.show_upload = true;
            } catch (e) {
                console.log('e-upload-e', e);
                this.$layer.msg(e.msg || '操作失败');
            }
        },
        async onGetMatchDetail(uuid) {
            try {
                const { data } = await GetMatchDetail({ uuid });
                console.log('match-detail', data);
                this.matchDetail = data;
                this.form.custom_field = data.custom_field ? data.custom_field.filter(i => i.use_type == 'upload') : [];
                // 确保 checkbox 类型的字段 value 初始化为数组
                this.form.custom_field.forEach(field => {
                    if (field.type === 'checkbox' && (!field.value || typeof field.value === 'string')) {
                        this.$set(field, 'value', []);
                    }
                });
            } catch (e) {
                console.log('get-match-detail-error', e);
            }
        },
        onSubmitWorksConfirm(data) {
            console.log('submit-works-data', data);
            this.form.image_list = data.image_list;
            this.show_upload = false;
            this.show_result = true;
        },
        onCloseSubmitWorks() {
            this.show_upload = false;
        },
        async onSubmitResultConfirm() {
            if (!this.form.image_list || !this.form.image_list.length) {
                this.$layer.msg('请完善作品图片');
                return;
            }
            const { data } = await SaveDraft({ image_list: this.form.image_list, scene: 'bc' });
            if (!data.uuid) {
                this.$layer.msg('操作失败,请稍后重试~');
                return;
            }
            this.$layer.msg('操作成功,即将跳转样衣定制~');
            setTimeout(() => {
                this.show_result = false;
                this.form.image_list = [];
                this.$router.push({ name: "WorkBenchDesign", query: { uuid: data.uuid, from: 'draft' } });
            }, 500);
        },
        onApply() {
            this.show_result = false;
            this.$router.push({ name: "ContestSampleApply", query: { uuid: this.currentMatchUuid } });
        },
        onCloseSubmitResult() {
            this.form.image_list = [];
            this.show_result = false;
            window.location.reload();
        }
    }
}
</script>
<style lang="scss" scoped>
.contest-log{
    width:100%;
    height:100%;
    display:flex;
    flex-direction:column;
    padding:28px 100px 100px 43px;
    user-select:none;
    .top{
        display:flex;
        align-items:center;
        justify-content:space-between;
        padding-bottom:11px;
        border-bottom:1px solid #d6d6d6;
        .title-box{
            display:flex;
            align-items:flex-end;
            column-gap:8px;
            .main-title{
                color:#1a1a1a;
                font-size:18px;
                font-weight:bold;
            }
            .desc{
                color:#999;
                font-size:14px;
            }
        }
        .search-box{
            background:#f3f4f6;
            border-radius:24px;
            flex:0 0 280px;
            height:36px;
            display:flex;
            align-items:center;
            padding:0 18px;
            .search-input{
                flex:1;
                height:100%;
                background:transparent;
                outline:none;
                border:none;
            }
            .search-ico{
                width:22px;
                height:22px;
                font-size:22px;
            }
        }
    }
    .list-body{
        width:100%;
        margin-top:24px;
        display:flex;
        flex-wrap:wrap;
        gap:20px;
        .list-item{
            width:calc(100% / 5 - 20px);
            border-radius:8px;
            border:1px solid rgba(0,0,0,0.08);
            display:flex;
            flex-direction:column;
            &:hover{
                border:1px solid #ff5967;
            }
            .item-img-box{
                width:100%;
                height:188px;
                border-top-left-radius:8px;
                border-top-right-radius:8px;
                position:relative;
                .tag{
                    padding:3px 10px;
                    color:#fff;
                    border-top-left-radius:8px;
                    border-bottom-right-radius:8px;
                    background:#999;
                    font-weight:bold;
                    font-size:12px;
                    z-index:2;
                    width:fit-content;
                    position:absolute;
                    top:0;
                    left:0;
                    &.ing{
                        background:#ff5967;
                    }
                    &.checking{
                        background:#ffba00;
                    }
                }
                .has-in{
                    width:100%;
                    background:rgba(0,0,0,0.5);
                    padding:7px 0;
                    text-align:center;
                    white-space:nowrap;
                    text-overflow:ellipsis;
                    overflow:hidden;
                    position:absolute;
                    bottom:0;
                    left:0;
                    font-size:14px;
                    z-index:2;
                    color:#f8f9fb;
                    &.has-win{
                        color:#ffd667;
                        font-weight:500;
                    }
                }
                .cover-img{
                    width:100%;
                    height:100%;
                    border-top-left-radius:8px;
                    border-top-right-radius:8px;
                    z-index:1;
                    object-fit:cover;
                }
            }
            .text-content-box{
                width:100%;
                padding:8px 12px 20px 12px;
                display:flex;
                flex-direction:column;
                .match-title{
                    width:100%;
                    text-overflow:ellipsis;
                    overflow:hidden;
                    white-space:nowrap;
                    margin-bottom:4px;
                }
                .match-time{
                    color:#666;
                    font-size:12px;
                    margin-bottom:12px;
                    text-overflow:ellipsis;
                    overflow:hidden;
                    white-space:nowrap;
                }
                .match-works-title{
                    width:100%;
                    font-size:14px;
                    display:flex;
                    align-items:center;
                    column-gap:5px;
                    .label{
                        color:#333;
                        white-space:nowrap;
                        flex-shrink:0;
                    }
                    .value{
                        color:#333;
                        white-space:nowrap;
                        text-overflow:ellipsis;
                        overflow:hidden;
                        &.no-works{
                            color:#b3b3b3;
                        }
                    }
                }
                .btn-box{
                    width:100%;
                    display:flex;
                    align-items:center;
                    column-gap:10px;
                    margin-top:20px;
                    .btn-item{
                        flex:0 0 calc(50% - 10px);
                        background:#f8f9fb;
                        border-radius:4px;
                        text-align:center;
                        color:#333;
                        font-size:14px;
                        cursor:pointer;
                        padding:5px 0;
                        &.active,&:hover{
                            color:#ff5967;
                            border:1px solid #ff5967;
                        }
                    }
                }
            }
        }
    }
}
</style>